import { policyTipsViewMoreDetailsLabel } from './PolicyTipsDetailsLearnMore.locstring.json';
import loc from 'owa-localize';
import * as React from 'react';
import InfoBarMessageWithCalloutAction from 'owa-info-bar/lib/components/InfoBarMessageWithCalloutAction';
import PolicyTipsViewState from '../store/schema/PolicyTipsViewState';

import { createPolicyTipsPeekInfoBarAction } from '../utils/createPolicyTipsPeekInfoBarAction';

export interface PolicyTipsDetailsLearnMoreProps {
    viewState: PolicyTipsViewState;
    linkStyle: string;
}

export const PolicyTipsDetailsLearnMore = (props: PolicyTipsDetailsLearnMoreProps) => {
    return (
        <>
            <span>{loc(policyTipsViewMoreDetailsLabel)}</span>
            {' ' /* This space preserves spacing between the message and the link. */}
            <InfoBarMessageWithCalloutAction
                {...createPolicyTipsPeekInfoBarAction(props.viewState)}
                className={props.linkStyle}
            />
        </>
    );
};
